

/* ======================================================
   COMPLETE THE LOOK – FINAL FINAL VERSION
====================================================== */


// let lastCTLSection = null;

// function forceRecalculateArrows(updateFn) {
//   requestAnimationFrame(() => {
//     requestAnimationFrame(() => {
//       updateFn();
//     });
//   });
// }

// function initCompleteTheLook(section) {
//   if (!section) return;

//   const slider = section.querySelector(".cart-complete-the-look__slider");
//   const btnPrev = section.querySelector(".cart-look-arrow.left");
//   const btnNext = section.querySelector(".cart-look-arrow.right");

//   if (!slider || !btnPrev || !btnNext) return;

//   const updateArrows = () => {
//   const itemsCount = slider.children.length;
//   const isDesktop = window.innerWidth > 768;

//   //  UX RULE: Desktop with 3 or fewer items never shows arrows
//   if (isDesktop && itemsCount <= 3) {
//     btnPrev.style.display = "none";
//     btnNext.style.display = "none";
//     slider.classList.add("is-static");
//     return;
//   }

//   // Default scroll-based logic (mobile + 4+ desktop)
//   const canScroll = slider.scrollWidth > slider.clientWidth + 1;

//   if (canScroll) {
//     btnPrev.style.display = "flex";
//     btnNext.style.display = "flex";
//     slider.classList.remove("is-static");
//   } else {
//     btnPrev.style.display = "none";
//     btnNext.style.display = "none";
//     slider.classList.add("is-static");
//   }
// };


//   // Initial + forced recalculation
//   updateArrows();
//   forceRecalculateArrows(updateArrows);

//   if (window.ResizeObserver) {
//     const ro = new ResizeObserver(updateArrows);
//     ro.observe(slider);
//   }

//   window.addEventListener("resize", updateArrows);

//   const itemsObserver = new MutationObserver(updateArrows);
//   itemsObserver.observe(slider, { childList: true });

//   const scrollAmount = () => {
//     const card = slider.querySelector(".cart-complete-the-look__card");
//     if (!card) return slider.clientWidth;
//     return card.offsetWidth + 14;
//   };

//   btnPrev.onclick = () => {
//     slider.style.scrollSnapType = "none";
//     slider.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
//     setTimeout(() => {
//       slider.style.scrollSnapType = "x proximity";
//     }, 350);
//   };

//   btnNext.onclick = () => {
//     slider.style.scrollSnapType = "none";
//     slider.scrollBy({ left: scrollAmount(), behavior: "smooth" });
//     setTimeout(() => {
//       slider.style.scrollSnapType = "x proximity";
//     }, 350);
//   };
// }

// function observeCompleteTheLook() {
//   const cart = document.querySelector(".cart-drawer, #CartDrawer, cart-drawer");
//   if (!cart) return;

//   const observer = new MutationObserver(() => {
//     const section = cart.querySelector(".cart-complete-the-look");
//     if (!section) return;

//     if (section !== lastCTLSection) {
//       lastCTLSection = section;
//       initCompleteTheLook(section);
//     }
//   });

//   observer.observe(cart, { childList: true, subtree: true });
// }

// document.addEventListener("DOMContentLoaded", observeCompleteTheLook);
// document.addEventListener("cart:rendered", observeCompleteTheLook);






let lastCTLSection = null;

function forceRecalculateArrows(updateFn) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateFn();
    });
  });
}

function initCompleteTheLook(section) {
  if (!section) return;



     /* =====================================
     INIT GUARD (CRITICAL, SAFE)
     Prevents duplicate listeners / flicker
   
  ===================================== */
  if (section.dataset.initialized === "true") return;
  section.dataset.initialized = "true";


  const slider = section.querySelector(".cart-complete-the-look__slider");
  const btnPrev = section.querySelector(".cart-look-arrow.left");
  const btnNext = section.querySelector(".cart-look-arrow.right");

  if (!slider || !btnPrev || !btnNext) return;

  /* =============================
      NEW: Visual fade logic ONLY
     (no disabled, no behavior change)
  ============================= */
  function updateArrowFade() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    btnPrev.classList.toggle("is-faded", slider.scrollLeft <= 1);
    btnNext.classList.toggle(
      "is-faded",
      slider.scrollLeft >= maxScroll - 1
    );
  }

  /* =============================
     EXISTING LOGIC (UNCHANGED)
  ============================= */
  const updateArrows = () => {
    const itemsCount = slider.children.length;
    const isDesktop = window.innerWidth > 768;

    // UX RULE: Desktop with 3 or fewer items never shows arrows
    if (isDesktop && itemsCount <= 3) {
      btnPrev.style.display = "none";
      btnNext.style.display = "none";
      slider.classList.add("is-static");
      return;
    }

    // Default scroll-based logic (mobile + 4+ desktop)
    const canScroll = slider.scrollWidth > slider.clientWidth + 1;

    if (canScroll) {
      btnPrev.style.display = "flex";
      btnNext.style.display = "flex";
      slider.classList.remove("is-static");
    } else {
      btnPrev.style.display = "none";
      btnNext.style.display = "none";
      slider.classList.add("is-static");
    }

    //  NEW: update fade state
    updateArrowFade();
  };

  // Initial + forced recalculation
  updateArrows();
  forceRecalculateArrows(updateArrows);

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(updateArrows);
    ro.observe(slider);
  }

  window.addEventListener("resize", updateArrows);

  const itemsObserver = new MutationObserver(updateArrows);
  itemsObserver.observe(slider, { childList: true });

  const scrollAmount = () => {
    const card = slider.querySelector(".cart-complete-the-look__card");
    if (!card) return slider.clientWidth;
    return card.offsetWidth + 14;
  };

  /* =============================
     EXISTING ARROW HANDLERS
     (UNCHANGED)
  ============================= */
  btnPrev.onclick = () => {
    slider.style.scrollSnapType = "none";
    slider.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
    setTimeout(() => {
      slider.style.scrollSnapType = "x proximity";
      updateArrowFade(); // keep visuals in sync
    }, 350);
  };

  btnNext.onclick = () => {
    slider.style.scrollSnapType = "none";
    slider.scrollBy({ left: scrollAmount(), behavior: "smooth" });
    setTimeout(() => {
      slider.style.scrollSnapType = "x proximity";
      updateArrowFade(); // keep visuals in sync
    }, 350);
  };

  // Sync fade on touch scroll
  slider.addEventListener("scroll", () => {
    requestAnimationFrame(updateArrowFade);
  });
}

function observeCompleteTheLook() {
  const cart = document.querySelector(".cart-drawer, #CartDrawer, cart-drawer");
  if (!cart) return;

  const observer = new MutationObserver(() => {
    const section = cart.querySelector(".cart-complete-the-look");
    if (!section) return;

    if (section !== lastCTLSection) {
      lastCTLSection = section;
      initCompleteTheLook(section);
    }
  });

  observer.observe(cart, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", observeCompleteTheLook);
document.addEventListener("cart:rendered", observeCompleteTheLook);













//   async function syncAddonCheckbox() {
//     const checkbox = document.getElementById('cart-addon-checkbox');
//     if (!checkbox) return;

//     const cart = await getCart();
//     checkbox.checked = !!findAddon(cart);
//   }

//   document.addEventListener('change', async (e) => {
//     const checkbox = e.target.closest('#cart-addon-checkbox');
//     if (!checkbox) return;

//     checkbox.disabled = true;
//     const cart = await getCart();
//     const addon = findAddon(cart);

//     if (checkbox.checked && !addon) {
//       await addAddon();
//     }

//     if (!checkbox.checked && addon) {
//       await removeAddon(addon.key);
//     }

//     checkbox.disabled = false;
//     document.dispatchEvent(new CustomEvent('cart:refresh'));
//   });

//   document.addEventListener('cart:refresh', syncAddonCheckbox);
//   document.addEventListener('DOMContentLoaded', syncAddonCheckbox);
// })();
